import React, { createContext, useContext, useEffect, useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import StoreSettingService from "services/store_setting";
import { Toaster, toaster } from "@/components/ui/toaster"
import { Button, CloseButton, Container, Dialog, Portal } from "@chakra-ui/react"
import { Helmet } from "react-helmet";

import { createSystem, defaultBaseConfig, defineConfig, defaultConfig , VStack, Text, Spinner} from "@chakra-ui/react"

import ProductService from "@/services/product"
import ProductTagService from "@/services/product_tag"
import ProductCategoryService from "@/services/product_category"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"
import _ from "lodash"
import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react"
const StoreContext = createContext(null);

export const StoreProductProvider = ({ children }) => {



    const { setProcessing, setPageTitle, showToast } = useApp();
    const { user } = useAuth();
    const [loading, setLoading] = useState(true)

    const service = new ProductService();
    const [products, setProduct] = useState([]);
    const [productsFilled, setProductFilled] = useState([]);
    const [tags, setTags] = useState([])
    const [categories, setCategories] = useState([])
    const [filter, setFilter] = useState({ tab: "tags" })
    useEffect(() => {
        loadTags();
        loadCategory();
    }, [])

    useEffect(() => {
        load();
    }, [user?.id])

    useEffect(() => {
        filterProduct();
    }, [products, filter])


    const load = async () => {
        setLoading(true);
        var data = await service.list({}, ["id", "name", "thumbnail", "original_price", "min_price", "max_price", "tags", "category"]);
        // console.log("data", data)
        setProduct(data)
        setLoading(false);

    }

    const filterProduct = () => {
        console.log("filter ", filter)
        if (filter.tab == "tags") {
            if (filter.tag) {
                var lst = products.filter(x => {
                    if (!_.isArray(x.tags)) {
                        return false;
                    }
                    return x.tags.includes(filter.tag)
                })
                setProductFilled(lst);
            } else {
                setProductFilled([...products])
            }
            return;
        }


        if (filter.tab == "category") {
            if (filter.category) {
                var lst = products.filter(x => {

                    return x.category == filter.category;
                })
                setProductFilled(lst);
            } else {
                setProductFilled([...products])
            }
            return;
        }

        setProductFilled([...products]);
    }

    const loadTags = async () => {
        const tagService = new ProductTagService();
        var data = await tagService.list();

        setTags(data);
    }

    const loadCategory = async () => {
        const cateService = new ProductCategoryService();
        var data = await cateService.list();

        setCategories(data);
    }
    const toogleTag = (id) => {
        if (filter.tag != id) {
            setFilter({ ...filter, tag: id, })
        } else {
            setFilter({ ...filter, tag: null })
        }
    }

    const toogleCategory = (id) => {
        if (filter.category != id) {
            setFilter({ ...filter, category: id, })
        } else {
            setFilter({ ...filter, category: null })
        }
    }

    const getProductsByList = async (list) => {
        var productList = [];
        for (let index = 0; index < list.length; index++) {
            const id = list[index];
            var p = products.find(x => x.id == id);
            if (p)
                productList.push(p);


        }
        return productList;

    }
    const getProductByFilter = async (filter) => {
        var lst = [...products]
        if (filter.tag) {
            lst = lst.filter(x => {
                var a = _.intersection(x.tags, filter.tag)
                if (a.length > 0)
                    return true;
                return false;
            })
        }
        if (filter.category) {
            lst = lst.filter(x => {
                return filter.category.includes(x.category)
            })
        }
        return lst;
    }




    return (
        <StoreContext.Provider value={{ products, getProductsByList, getProductByFilter }}>
            {loading ?
                <>
                    <VStack>
<div style={{height:100, width:"100%"}}></div>
                        <Spinner size="lg" color={"colorPalette.600"} />
                        <Text  color={"colorPalette.600"}  >Đang tải</Text>
                    </VStack>

                </>
                :
                <>
                    {children}
                </>
            }



        </StoreContext.Provider>
    );
};

export const useStoreProduct = () => {
    return useContext(StoreContext);
}